import { ArticlesList } from '../../../components/News/AdminNewsList'

export const Articles = () => {
    return <ArticlesList />
}
